export function isInFrame() {
    return window.top !== window.self
}
